/* non-sensical library */\ndefine([], function() {\n  var number = 1;\n\n  function addNumber(n) {\n    return n + number;\n  }\n\n  return addNumber;\n});\n